export type Language = "hu" | "en" | "de" | "pl" | "cs" | "es" | "fr" | "ro" | "nl" | "pt" | "sv" | "da" | "no" | "fi" | "lt" | "bg" | "hr" | "at" | "it";

export const DEFAULT_LANGUAGE: Language = "hu";
export const LANGUAGE_STORAGE_KEY = "bespire_language";

export const SUPPORTED_LANGUAGES: Language[] = ["hu", "en", "de", "pl", "cs", "es", "fr", "ro", "nl", "pt", "sv", "da", "no", "fi", "lt", "bg", "hr", "at", "it"];

export const LANGUAGE_NAMES: Record<Language, string> = {
  hu: "Magyar",
  en: "English", 
  de: "Deutsch",
  pl: "Polski",
  cs: "Čeština",
  es: "Español",
  fr: "Français",
  ro: "Română",
  nl: "Nederlands",
  pt: "Português",
  sv: "Svenska",
  da: "Dansk",
  no: "Norsk",
  fi: "Suomi",
  lt: "Lietuvių",
  bg: "Български",
  hr: "Hrvatski",
  at: "Österreichisch",
  it: "Italiano"
};

export const isLanguageSupported = (lang: string): lang is Language => {
  return SUPPORTED_LANGUAGES.includes(lang as Language);
};